<button [color]="toggled() ? 'accent' : 'warn'" raised tiime-button icon (click)="emitToggle()">
  @if (toggled()) {
    <mat-icon [tiimeTooltip]="toggledTooltipMessage()">add</mat-icon>
  } @else {
    <mat-icon [tiimeTooltip]="untoggledTooltipMessage()">remove</mat-icon>
  }
</button>
